import { combineReducers } from 'redux';
import localStorage from 'redux-persist/lib/storage';

// slices
import authReducer from './slices/auth';
import imagesReducer from './slices/images';
import mainCategoryReducer from './slices/mainCategory';
import subCategoryReducer from './slices/subCategory';
import productReducer from './slices/product';
import cartReducer from './slices/cart';
import customerReducer from './slices/customer';
import orderReducer from './slices/order';
import myOrderReducer from './slices/myOrder';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage: localStorage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  auth: authReducer,
  images: imagesReducer,
  mainCategory: mainCategoryReducer,
  subCategory: subCategoryReducer,
  product: productReducer,
  cart: cartReducer,
  customer: customerReducer,
  order: orderReducer,
  myOrder: myOrderReducer,
});

export { rootPersistConfig, rootReducer };
